import MainImage from "./images/main.jpg";
import Room1 from "./images/room1.jpg";
import Room2 from "./images/room2.jpg";
import Room3 from "./images/room3.jpg";
import Room4 from "./images/room4.jpg";
import Room5 from "./images/room5.jpg";
import Room6 from "./images/room6.jpg";
import Room7 from "./images/room7.jpg";
import Room8 from "./images/room8.jpg";
import Room9 from "./images/room9.jpg";
import Room10 from "./images/room10.jpg";
import Room11 from "./images/room11.jpg";
import Room12 from "./images/room12.jpg";
import Room13 from "./images/room13.jpg";
import Room14 from "./images/room14.jpg";

const images = {
  MainImage,
  Room1,
  Room2,
  Room3,
  Room4,
  Room5,
  Room6,
  Room7,
  Room8,
  Room9,
  Room10,
  Room11,
  Room12,
  Room13,
  Room14,
};

export default images;
